document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("load-more-podcasts");
  const list = document.getElementById("podcast-more-list");
  if (!btn || !list) return;

  let loading = false;

  btn.addEventListener("click", async () => {
    console.log('carregado');
    if (loading) return;
    loading = true;

    const offset = parseInt(btn.dataset.offset || "0", 10);
    const perPage = parseInt(btn.dataset.perPage || "5", 10);

    const form = new FormData();
    form.append("action", "load_more_podcasts");
    form.append("offset", String(offset));
    form.append("per_page", String(perPage));

    btn.disabled = true;
    const oldText = btn.textContent;
    btn.textContent = "carregando...";

    try {
    console.log("ajaxUrl:", podcastAjax.ajaxUrl);
        const res = await fetch(podcastAjax.ajaxUrl, { method: "POST", body: form });
        const txt = await res.text();
        const data = JSON.parse(txt);
      

      if (data.success && data.data && data.data.html) {
        list.insertAdjacentHTML("beforeend", data.data.html);
        btn.dataset.offset = String(data.data.nextOffset);

        if (!data.data.hasMore) {
          btn.remove();
        } else {
          btn.disabled = false;
          btn.textContent = oldText;
        }
      } else {
        btn.disabled = false;
        btn.textContent = oldText;
        alert("Não foi possível carregar mais episódios.");
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = oldText;
      alert("Erro ao carregar mais episódios.");
    } finally {
      loading = false;
    }
  });
});